/**
 * 검색 0건 폴백 전용 지명 사전.
 *
 * 용도: 사용자가 "성수", "하카타"처럼 **도시보다 좁은 지명**으로 검색해 상품이 0건일 때,
 * 그 지명의 좌표를 폴백 추천("이 지역의 다른 상품")의 기준점으로 삼기 위한 데이터.
 * `CITIES`(도시) → 이 사전 → `HOT_SPOTS` 순으로 조회된다.
 *
 * `HOT_SPOTS`와 분리한 이유: HOT_SPOTS는 홈 화면에 노출되는 UI 데이터라 이미지·큐레이션이
 * 필요하지만, 이 사전은 화면에 뜨지 않고 좌표 해석에만 쓰이므로 이미지가 필요 없다.
 * 덕분에 운영자가 부담 없이 항목을 늘릴 수 있다.
 *
 * 운영 규칙:
 *  - SA "없는 상품 검색어" 로그에서 새 지명이 보이면 여기에 추가한다 (배포만 하면 반영).
 *  - **좌표 정밀도는 중요하지 않다.** 폴백은 이 좌표에서 시작해 ×3 → 도시급으로 반경을
 *    넓혀가므로 대표 지점 기준 ±1km 오차는 결과에 영향을 주지 않는다.
 *  - `HOT_SPOTS`·`CITIES`에 이미 있는 지명은 등재하지 않는다 (그쪽에서 이미 잡힌다).
 *    별칭만 보강하고 싶은 경우에도 여기 넣지 말고 원본 데이터를 고친다.
 *  - `names`는 소문자·공백 정규화 후 **토큰 단위 완전 일치**로 비교된다. 부분 문자열
 *    매칭이 아니므로 "성수동"처럼 흔히 붙여 쓰는 형태도 별도 항목으로 넣어야 한다.
 *  - `cityId`는 반드시 `CITIES`에 존재하는 id여야 한다 (라벨·도시급 반경이 여기서 나온다).
 */

import { KR_PLACES } from "./kr";
import { JP_PLACES } from "./jp";
import { TW_PLACES } from "./tw";

export interface SearchPlace {
  /** "KR-SEL-SEONGSU" 형식 — 도시 id + 지명 슬러그 */
  id: string;
  /** 소속 도시 (CITIES의 id) */
  cityId: string;
  /** 모든 언어 표기 + 통용 별칭을 평탄화한 배열 */
  names: string[];
  coordinates: { latitude: number; longitude: number };
}

/**
 * 수기 큐레이션 사전 (국가별 파일을 합친 것). 자동 생성 역 데이터(STATION_PLACES)는
 * 공용 번들에서 빼려고 여기서 재노출하지 않는다 — lib/search/station-places 참고.
 */
export const SEARCH_PLACES: SearchPlace[] = [...KR_PLACES, ...JP_PLACES, ...TW_PLACES];
